export function mapProfileFromApi(profile, vendorId) {
  if (!profile) return null;

  return {
    id: vendorId,
    nomeReferente: profile.nomeReferente ?? "",
    cognomeReferente: profile.cognomeReferente ?? "",
    nomeCommerciale: profile.nomeCommerciale ?? "",
    ragioneSociale: profile.ragioneSociale ?? "",
    codiceFiscale: profile.codiceFiscale ?? "",
    indirizzoEmail: profile.indirizzoEmail ?? profile.email ?? "",
    indirizzoPec: profile.indirizzoPec ?? "",
    codiceSDI: profile.codiceSDI ?? "",
    sitowebAziendale: profile.sitowebAziendale ?? "",
    partitaIVA: profile.partitaIVA ?? "",
    numeroTelefono: profile.numeroTelefono ?? "",
    emailReferente: profile.emailReferente ?? "",
    telefonoReferente: profile.telefonoReferente ?? "",
    emailPubblica: profile.emailPubblica ?? "",
    urlSftp: profile.urlSftp ?? "",
    utenteSftp: profile.utenteSftp ?? "",
    passwordSftp: profile.passwordSftp ?? "",
    indirizzoVia: profile.indirizzoVia ?? "",
    indirizzoCivico: profile.indirizzoCivico ?? "",
    indirizzoCap: profile.indirizzoCap ?? "",
    indirizzoCitta: profile.indirizzoCitta ?? "",
    indirizzoProvincia: profile.indirizzoProvincia ?? "",
    indirizzoRegione: profile.indirizzoRegione ?? "",
    indirizzoStato: profile.indirizzoStato ?? "",
    logo: profile.logo ?? "",
  };
}
